import type { HolterDirectExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterDirectExaminationRequestSchemas';
import { initialMedicationData } from '@common/validation/customControls/cardiology/holter/utils/medicationUtils';
import { processActivityInitialProfessionalSummaryData } from '@common/validation/customControls/processActivityProfessionalSummaryData';
import { holterConfigureInitialData } from '../holterConfigure/holterConfigureData';
import {
    holterAdviceInitialData,
    holterAnamnesisSectionInitialData,
    holterEcgSectionInitialData,
    holterExaminationRequestReferralInitialData,
    holterVoorgeschiedenisSectionInitialData,
} from '../utils/initialData';

export const holterDirectExaminationRequestInitialData: HolterDirectExaminationRequestData = {
    ...holterExaminationRequestReferralInitialData,
    ...holterConfigureInitialData,
    ...processActivityInitialProfessionalSummaryData,
    ...holterEcgSectionInitialData,
    ...holterAnamnesisSectionInitialData,
    ...holterAdviceInitialData,
    medication: initialMedicationData,
    opnameduur: null,
    patient_geslacht: null,
    patientUsesMedication: null,
    relevante_voorgeschiedenis: holterVoorgeschiedenisSectionInitialData,
    type_onderzoek: null,
} as const;
